/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";
import "@material/layout-grid/dist/mdc.layout-grid.css";
import Direction from "../../../../commons/Direction";
import { GridCell as MdGridCell } from "@rmwc/grid";

export type GridCellProps = {
  dir?: Direction;
  align?: "top" | "middle" | "bottom";
  span?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  desktop?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  tablet?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  phone?: 1 | 2 | 3 | 4;
  order?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  className?: string;
};

const GridCell: FC<GridCellProps> = ({
  children,
  className,
  dir = Direction.RTL,
  align,
  span,
  desktop,
  tablet,
  phone,
  order,
}) => {
  return (
    <MdGridCell
      css={css``}
      dir={dir.valueOf()}
      align={align}
      span={span}
      desktop={desktop}
      tablet={tablet}
      phone={phone}
      order={order}
      className={className}
    >
      {children}
    </MdGridCell>
  );
};

export default GridCell;
